import React, { CSSProperties } from "react"
import { useDragLayer, XYCoord } from "react-dnd"
import { DragObjectTypes } from "../../dragObjects"
import GridSizedTile from "../grid-sized-tile"

export default function DragLayer() {
    const { item, itemType, isDragging, clientOffset } = useDragLayer(monitor => ({
        isDragging: monitor.isDragging(),
        clientOffset: monitor.getClientOffset(),
        itemType: monitor.getItemType(),
        item: monitor.getItem(),
    }))

    if (!isDragging) return <div />

    let element;
    switch (itemType) {
        case DragObjectTypes.Tile:
            element = <GridSizedTile {...item} />
    }
    return (
        <div style={getDragLayerStyle(clientOffset)}>
           {element}
        </div>
    )

}
function getDragLayerStyle(clientOffset: XYCoord | null): CSSProperties {
    if (clientOffset === null) {
        return { display: "none" }
    }
    return {
        position: "fixed",
        zIndex: 100,
        pointerEvents: "none",
        top: clientOffset?.y,
        left: clientOffset?.x,
        transform: "translate(-50%, -50%)",
    }
}